// import BlackFriday from '@elem/compCommon/PillarPageActivities/BlackFriday';
import AMZMemberDay from '@elem/compCommon/PillarPageActivities/AMZMemberDay';
// import MemberDrainageBar from '@elem/compCommon/MemberDrainageBar';
import A from './components/A';
import IndexDynamic from './indexDynamic';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
//const IndexDynamic = dynamic(() => import('./indexDynamic'), { ssr: true });

export const comingSoonTime = '2025/04/26 15:00:00 GMT+8';

export default function RV() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`RV ${css['RV']}`}>
            <A />
            <AMZMemberDay />
            <IndexDynamic />
        </div>
    );
}
